import { Trans, useTranslation } from 'next-i18next'

export default function StatBanner(): React.ReactElement {
  const { t } = useTranslation('abTestLanding')

  return (
    <div className="flex flex-col items-center gap-2 py-8 text-center md:gap-4 md:py-12">
      <p className="bg-task-algebra-gradient bg-clip-text font-black text-transparent text-v4-stat-m md:text-v4-stat">
        {t('v4.hero.stat.number')}
      </p>
      <p className="text-lg font-bold text-black-ink md:text-h3">
        <Trans
          components={{ hl: <span className="rounded-small bg-lime-200 px-1.5 py-0.5" /> }}
          i18nKey="v4.hero.stat.solvedBy"
          t={t}
        />
      </p>
    </div>
  )
}
